module.exports = __webpack_public_path__ + "static/img/13.e6a4138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/13.png
// module id = 4utg
// module chunks = 1